<template>
  <div ref="slider">
    <slot name="control-prev" />
    <div class="sliderContainer">
      <div class="slider__list" data-slider-list>
        <div
          v-for="(item, index) in sliderItems"
          v-bind:key="index"
          class="slider__item"
          data-slider-slide
          aria-roledescription="slide"
          :aria-label="getAriaLabelSliderItem(index)"
        >
          <picture
            class="picture has-aspect-ratio is-1by1-desktop is-1by1-mobile"
          >
            <template v-for="(data, i) in item">
              <source
                :media="data.media"
                :sizes="data.Sizes"
                :data-srcset="data.srcset"
                :key="i"
                v-if="data.src == null"
              />
              <img
                v-bind:key="i"
                v-if="data.src != null && enablelazyLoad"
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                :data-src="data.src"
                :alt="data.altText"
                class="lazy"
              />
              <img
                v-bind:key="i"
                v-if="data.src != null && !enablelazyLoad"
                :src="data.src"
                :alt="data.altText"
              />
            </template>
          </picture>
        </div>
      </div>
      <slot name="vto"></slot>
    </div>
    <slot name="control-next" />
    <div class="thumbanial-container">
      <div
        class="slider --controls-centered --cards card-list"
        ref="thumbnailslider"
      >
        <button
          type="button"
          class="slider-control slider-control__prev product-slider-click-previous thumbnailprev"
          :class="[isSliderEnable ? '' : 'hideBtn']"
          data-slider-control="prev"
          data-analytics='{"domEvent":"click","locatorType":"className","locatorQuery":"product-slider-click-previous","timeduration":"","scrollratio":"","triggerOnExternalApiResponse":false,"eventName":"","parentSelector":"","childSelector":"","taggingData":null}'
          :aria-label="paginationPreviousAriaLabel"
        >
          <svg role="img" :aria-label="ariaLabelPrevious">
            <use
              xlink:href="#arrow-left"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            ></use>
          </svg>
        </button>
        <ul
          class="slider-control__dots lp-thumbnail slider__list"
          :aria-label="ariaLabelPagination"
          data-slider-list
          :class="[isSliderEnable ? 'isSliderEnable' : '']"
          role="tabpanel"
        >
          <li
            class="slider-control__dot slider__item"
            v-for="(item, index) in thumbnailItems"
            v-bind:key="index"
            data-slider-slide
            role="tablist"
          >
            <div class="card">
              <button
                class="pagination-btn"
                :aria-label="paginationItemAriaLabel.replace('{n}', index + 1)"
                aria-current="true"
                data-slider-control
                :data-slide-index="index"
                @click="onSliderChange('pagination')"
                role="tab"
              >
                <img
                  v-if="enablelazyLoad"
                  :alt="item.altText"
                  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                  :data-src="item.src"
                  class="lazy"
                />
                <img
                  v-if="!enablelazyLoad"
                  :alt="item.altText"
                  :src="item.src"
                />
              </button>
            </div>
          </li>
        </ul>
        <button
          type="button"
          class="slider-control slider-control__next product-slider-click-next thumbnailnext"
          :class="[isSliderEnable ? '' : 'hideBtn']"
          data-slider-control="next"
          data-analytics='{"domEvent":"click","locatorType":"className","locatorQuery":"product-slider-click-next","timeduration":"","scrollratio":"","triggerOnExternalApiResponse":false,"eventName":"","parentSelector":"","childSelector":"","taggingData":null}'
          :aria-label="paginationNextAriaLabel"
        >
          <svg role="img" :aria-label="ariaLabelNext">
            <use
              xlink:href="#arrow-right"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            ></use>
          </svg>
        </button>
      </div>
    </div>

    <div role="alert" aria-live="assertive" class="anounce-section">
      <h2>{{ slideChangeAnnouceTitle }}</h2>
      <p>{{ slideChangeAnnouceDesc }}</p>
    </div>
  </div>
</template>

<script>
import { getSlider } from 'Utils/BaseSlider';

let sliderInstance = null;
let thumbnailsliderInstance = null;
let mediaGalleryEl;

export default {
  name: 'media-gallery',

  props: {
    variants: [],
    thumbnails: [],
    ariaLabelNext: {
      type: String,
      required: false,
      default: 'Next',
    },
    ariaLabelPrevious: {
      type: String,
      required: false,
      default: 'Previous',
    },
    ariaLabelPagination: {
      type: String,
      required: false,
      default: 'Pagination',
    },
    paginationNextAriaLabel: {
      type: String,
      required: false,
      default: 'Next product functionality pagination slide',
    },
    paginationPreviousAriaLabel: {
      type: String,
      required: false,
      default: 'Previous product functionality pagination slide',
    },
    paginationItemAriaLabel: {
      type: String,
      required: false,
      default: 'go to slide {n}',
    },
    sliderItemAriaLabel: {
      type: String,
      required: false,
      default: 'Slide {n} of {x}',
    },
    activeSlideAnnouce: {
      type: String,
      required: false,
      default: 'Slide {x} displayed.',
    },
    slideClickedAnnouce: {
      type: String,
      required: false,
      default: 'Slide {n} of {x} displayed',
    },
    paginationClickedAnnouce: {
      type: String,
      required: false,
      default: 'Pagination slides {n} to {x} displayed.',
    },
  },
  data() {
    return {
      sliderItems: [],
      thumbnailItems: [],
      enablelazyLoad: true,
      isSliderEnable: false,
      isDesktop: window.innerWidth >= 1024,
      isInitialLoad: true,
      slideChangeAnnouceTitle: '',
      slideChangeAnnouceDesc: '',
    };
  },
  created() {
    let singleVariant = this.variants && this.variants[0];
    let singleVariantthumbnail = this.thumbnails && this.thumbnails[0];
    singleVariant?.images.forEach((data) => {
      this.sliderItems.push(data);
    });
    singleVariantthumbnail?.images.forEach((data) => {
      this.thumbnailItems.push(data);
    });
    this.checkSlider();
  },
  mounted() {
    mediaGalleryEl = document.getElementsByClassName('media-gallery');
    let vtocontainer = document.getElementsByClassName('vto-container');
    if (vtocontainer.length > 0) {
      let btnWidth = vtocontainer[0].offsetWidth;
      vtocontainer[0].style.left = 'calc(50% - ' + btnWidth / 2 + 'px)';
    }
    eventBus.$on('shade::selected', this.updateMediaItems);
    eventBus.$on('package::selected', (productEan) => {
      if (this.isInitialLoad) {
        this.isInitialLoad = false;
        this.enablelazyLoad = true;
      } else {
        this.enablelazyLoad = false;
        this.updateMediaItems(productEan);
      }
    });
    this.initSlider();
    this.enablelazyLoad = true;

    const handleSlideChange = () => this.onSliderChange('slide');
    this.bindSliderButton('media-gallery-slide-prev-btn', handleSlideChange);
    this.bindSliderButton('media-gallery-slide-next-btn', handleSlideChange);

    // Monitor main slider for changes (mouse drag/swipe) and sync thumbnail
    this.$nextTick(() => {
      this.setupSliderMonitoring();
    });
  },
  destroyed() {
    if (this._monitoringFrame) {
      cancelAnimationFrame(this._monitoringFrame);
    }
    sliderInstance.clear();
  },
  methods: {
    checkSlider() {
      let sliderCount = this.isDesktop ? 5 : 4;
      if (this.thumbnailItems.length > sliderCount) {
        this.isSliderEnable = true;
      } else {
        this.isSliderEnable = false;
      }
    },
    initSlider() {
      sliderInstance = getSlider(this.$refs.slider, 'thumbnail');
      thumbnailsliderInstance = getSlider(
        this.$refs.thumbnailslider,
        'default'
      );
      sliderInstance.init();
      thumbnailsliderInstance.init();
    },
    updateMediaItems(productEan) {
      this.sliderItems = [];
      this.thumbnailItems = [];
      this.variants.forEach((data) => {
        if (data.EAN == productEan) {
          data.images.forEach((img) => {
            this.sliderItems.push(img);
          });
        }
      });
      this.thumbnails.forEach((data) => {
        if (data.EAN == productEan) {
          data.images.forEach((img) => {
            this.thumbnailItems.push(img);
          });
        }
      });
      this.checkSlider();
      sliderInstance.clear();
      thumbnailsliderInstance.clear();
      sliderInstance.slides = [];
      thumbnailsliderInstance.slides = [];
      this.$nextTick(() => {
        this.initSlider();
      });
    },
    getAriaLabelSliderItem(index) {
      if (
        !this.sliderItemAriaLabel.includes('n') ||
        !this.sliderItemAriaLabel.includes('x')
      ) {
        return this.sliderItemAriaLabel;
      }
      return this.sliderItemAriaLabel
        .replace('{n}', index + 1)
        .replace('{x}', this.sliderItems.length);
    },
    getActiveSlide() {
      if (!mediaGalleryEl.length) return -1;
      
      const paginationButtonsEl =
        mediaGalleryEl[0].querySelectorAll('.pagination-btn');
      if (!paginationButtonsEl.length) return -1;

      for (let i = 0; i < paginationButtonsEl.length - 1; i += 1) {
        if (paginationButtonsEl[i].ariaSelected === 'true') return i + 1;
      }

      return -1;
    },
    bindSliderButton(id, handler) {
      const buttonEl = document.getElementById(id);
      if (!buttonEl) return;
      
      buttonEl.addEventListener('click', handler);
    },
    setupSliderMonitoring() {
      // Monitor the main slider's current index changes for mouse drag/swipe
      if (!sliderInstance) return;
      
      let lastIndex = sliderInstance.current;
      const checkIndexChange = () => {
        if (sliderInstance && sliderInstance.current !== lastIndex) {
          lastIndex = sliderInstance.current;
          this.scrollThumbnailIntoView(lastIndex);
        }
        this._monitoringFrame = requestAnimationFrame(checkIndexChange);
      };
      
      checkIndexChange();
    },
    scrollThumbnailIntoView(index) {
      // Scroll the thumbnail at the given index into view
      this.$nextTick(() => {
        const thumbSlider = this.$refs.thumbnailslider;
        if (thumbSlider) {
          const btns = thumbSlider.querySelectorAll('.pagination-btn');
          if (btns && btns[index]) {
            btns[index].scrollIntoView({ 
              behavior: 'smooth', 
              block: 'nearest', 
              inline: 'center' 
            });
          }
        }
      });
    },
    onSliderChange(paginationOrSlide) {
      setTimeout(() => {
        const activeSlider = this.getActiveSlide();
        this.slideChangeAnnouceDesc = this.activeSlideAnnouce.replace(
          '{x}',
          activeSlider
        );

        // Scroll the active thumbnail into view
        this.$nextTick(() => {
          const thumbSlider = this.$refs.thumbnailslider;
          if (thumbSlider) {
            const btns = thumbSlider.querySelectorAll('.pagination-btn');
            if (btns && btns[activeSlider - 1]) {
              btns[activeSlider - 1].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          }
        });

        switch (paginationOrSlide) {
          case 'pagination':
            this.slideChangeAnnouceTitle = this.paginationClickedAnnouce
              .replace('{n}', activeSlider)
              .replace('{x}', this.sliderItems.length);
            break;
          case 'slide':
            this.slideChangeAnnouceTitle = this.slideClickedAnnouce
              .replace('{n}', activeSlider)
              .replace('{x}', this.sliderItems.length);
            break;
        }
      }, 1);
    },
  },
};
</script>
